import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '重要规则',
    type: 'RULEM_RM_IMPORTANT_RULE',
}
